import React, { useState } from 'react';
import "../Styles/Forgot.css";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Forgot() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post('https://api.uniums.com/api/forgot-password', { email });
            toast.success(response.data.message); 
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred'); 
        } finally {
            setLoading(false); 
        }
    };

    return (
        <div className="forgot-container">
            <div className="forgot-box">
                <h2 className="forgot-title">Forgot Password</h2>
                <p className="forgot-description">
                    Please enter your email address below. We'll send you a link to reset your password.
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="input_group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="Enter your email"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="submit_btn"
                        disabled={loading}  
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div className="back-to-login">
                    <p>Remember your password? <Link to={'/'}>Login here</Link></p>
                </div>
            </div>
            <ToastContainer /> 
        </div>
    );
}

export default Forgot;
